import { GARAGE_STATUS } from '$app/apps/bookings/containers/BookingPage/constants';
import get from 'lodash/get';


export default function(booking) {
  const msn = get(booking, ['masterStatus', 'masterStatusName'], get(booking, ['masterStatusName'], 'UNKNOWN'));
  switch (msn) {
    case 'AT_GARAGE': {
      const { garageStatus } = booking;
      if (garageStatus === GARAGE_STATUS.DRAFT) return 'QUOTING_EXTRA_WORK';
      if (garageStatus === GARAGE_STATUS.FIXTER_REVIEW) return 'TO_REVIEW';
      if (garageStatus === GARAGE_STATUS.CUSTOMER_REVIEW) return 'CUSTOMER_REVIEWING';
      if (garageStatus === GARAGE_STATUS.CUSTOMER_REVIEWED) return 'CUSTOMER_REVIEWED';
      return 'AT_GARAGE';
    }
    case 'PENDING': {
      return 'PENDING';
    }
    case 'AWAITING_PICKUP': {
      const { collectionDeliveryOption } = booking;
      if (collectionDeliveryOption === 'CustomerC&D') return 'AWAITING_DROPOFF';
      return 'AWAITING_PICKUP'
    }
    default:
      return msn;
  }
}
